import React from 'react';
import './FundingSourceChosen.scss';
import BankSnapshot from '../BankSnapshot/BankSnapshot';
import SingleBank from '../SingleBank/SingleBank';
import Case from '../../Shared/Switch/Case';
import Switch from '../../Shared/Switch/Switch';
import NoBank from '../NoBank/NoBank';
import NoBankStopTransfer from '../NoBankStopTransfer/NoBankStopTransfer';

const FundingSourceChosen = ({
  isSalesforceRep,
  customerWebViewEnabled,
  actions,
  availableSources,
  completed,
  editMode,
  error,
  selectedBank,
  toggleEditMode,
  stopTransfer,
}) => {
  switch (availableSources.length) {
    case 0:
      return (
        <div>
          <Switch test={stopTransfer}>
            <Case value={false}>
              <NoBank
                isSalesforceRep={isSalesforceRep}
                customerWebViewEnabled={customerWebViewEnabled}
                actions={actions}
                error={error}
                fundingSource={availableSources}
              />
            </Case>
            <Case value={true}>
              <NoBankStopTransfer
                isSalesforceRep={isSalesforceRep}
                customerWebViewEnabled={customerWebViewEnabled}
                actions={actions}
                error={error}
                fundingSource={availableSources}
              />
            </Case>
          </Switch>
        </div>
      );

    case 1:
      return (
        !completed && (
          <SingleBank
            error={error}
            fundingSource={availableSources}
            actions={actions}
          />
        )
      );

    default:
      return (
        selectedBank &&
        !completed && (
          <div>
            <div className="funding-source-chosen-bank-heading funding-source-chosen-heading">
              CHOSEN BANK
            </div>
            <BankSnapshot
              bank={selectedBank}
              toggleEdit={toggleEditMode}
              editMode={editMode}
              completed={completed}
              isReview={false}
            />
          </div>
        )
      );
  }
};

export default FundingSourceChosen;
